<template>
	<div class="myAccount pt-[50px] pl-[50px] pr-[100px] box-border">
		<div class="flex items-center justify-between">
			<div class="text-[14px] flex-1">
				<label class=" text-[#000000] mr-[48px]">{{langInfo['My balance']}}</label>
				<label class="text-[#FF0000]">{{userInfo.money ||'0.00'}}</label>
			</div>
			<div @click="withdrawalBtn()"
				class="min-w-[167px] h-[36px] px-[10px] box-border cursor-pointer leading-[36px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['Apply for withdrawal']}}
			</div>
		</div>
		<div class="text-[14px]  text-[#000000] mb-[14px]">
			{{langInfo['Balance details']}}
		</div>
		<div class="" v-if="isFinish&&tableData.length>0">
			<el-table :data="tableData" max-height="600" border style="width: 100%" class="mb-[20px]">
				<el-table-column prop="create_time" :label="langInfo['Operation time']" width="180">
				</el-table-column>
				<el-table-column prop="memo" :label="langInfo['Operating Procedures']" width="100">
				</el-table-column>
				<el-table-column prop="money" :label="langInfo['Balance change']" width="100">
					<template slot-scope="scope">
						<div :class="scope.row.money>0?'text-[#FF0000]':'text-[#73D13D]'" class=" text-[16px] ">
							{{scope.row.money}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="after" :label="langInfo['Remain after operation']" width="100">
				</el-table-column>
				<el-table-column prop="memo" :label="langInfo['Details remarks']">
				</el-table-column>
			</el-table>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<emptyPage v-else-if="isFinish&&tableData.length==0" :title="langInfo.no_data_available">
		</emptyPage>


		<!-- 提现 -->
		<el-dialog title="" @close="withdrawalClose" :visible.sync="withdrawalVisible" :close-on-click-modal="false"
			width="50%" center>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
				<el-form-item :label="langInfo['Withdrawal amount']" prop="price">
					<el-input v-model="ruleForm.price"
						:placeholder="langInfo['Please enter the amount to withdraw']"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="withdrawalClose()">{{langInfo.cancel}}</el-button>
					<el-button type="primary" @click="submitForm('ruleForm')">{{langInfo.submit}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			emptyPage
		},
		data() {
			return {
				langInfo: {},
				userInfo: {},
				isFinish: false,
				page: 1,
				limit: 10,
				total: 0,
				tableData: [],
				// 提现
				withdrawalVisible: false,
				ruleForm: {
					price: '',
				},
				rules: {
					price: [
						{ required: true, message: '', trigger: 'blur' } //请输入提现金额
					],

				},
			}
		},
		mounted() {
			this.getUserInfo()
			this.user_money_log()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.rules.price[0].message = this.langInfo['Please enter the amount to withdraw']
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.rules.price[0].message = this.langInfo['Please enter the amount to withdraw']
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			currentChange(e) {
				console.log(e);
				this.page = e
				this.isFinish = false
				this.user_money_log()
			},
			user_money_log() {
				this.$api.user_money_log({
					page: this.page,
					limit: this.limit
				}).then((res) => {
					console.log(res.data);
					this.tableData = res.data.list
					this.total = res.data.count
					this.isFinish = true

					console.log(this.tableData.length);

				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 提现

			withdrawalBtn(item, index) {
				if (!this.userInfo.money || this.userInfo.money <= 0) {
					this.$message({
						message: "暂无可提现金额",
						type: 'warning'
					})
					return
				}
				this.withdrawalVisible = true
			},
			withdrawalClose() {
				this.withdrawalVisible = false
				this.ruleForm.price = ""

			},
			submitForm(formName) {
				var that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						that.$api.user_finance({
							price: this.ruleForm.price,
						}).then((res) => {
							console.log(res);
							this.$message({
								message: res.msg,
								type: 'success'
							})
							that.getUserInfo()
							that.page = 1
							that.total = 0
							that.user_money_log()
						}).catch((error) => {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
						})

						setTimeout(() => {
							that.withdrawalVisible = false
							that.ruleForm.price = ""
						}, 400)
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}

	}
</script>

<style scoped>
	/deep/.el-table__header th.el-table__cell {
		background-color: #F8F8F8;
		height: 56px;
	}
</style>